import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Grid,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Select,
  MenuItem,
  Snackbar,
  Stack,
  Checkbox,
  FormGroup,
} from "@mui/material";
import CustomSnackbar from "../../../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomTextFieldComp from "../../../../../newTestPrep/newComponent/customTextFieldComp";
export default function ClassextentionForm({ selecteddata, onClose }) {
  const enquiryId = selecteddata?.enquiry_id;
  const clasId = selecteddata.class_id?.id;
  const packageId = selecteddata.package_id?.id;
  const studentId = selecteddata?.student_id;

  const userId = localStorage.getItem("userId");

  console.log("selectedData", selecteddata?.currency);
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const [statusname, setstatusname] = useState("pending");
  const [sessions, SetSessions] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [selectedType, setSelectedType] = useState("fullPayment");
  const [paymentmodes, setPaymentModes] = useState([]);
  const [paymentMode, setPaymentMode] = useState(null);
  const [offerDiscount, setOfferDiscount] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [classextension, setClassextention] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  const handleChange = (event) => {
    setstatusname(event.target.value);
  };

  const handlesessionchange = (e) => {
    setDiscount("");
    SetSessions(e.target.value);
  };

  const handleOfferDiscountChange = (value) => {
    setDiscount(null);
    setOfferDiscount(value); // converts string to boolean
  };
  const handleDiscountchange = (e) => {
    setDiscount(e.target.value);
  };

  const Total_Amount =
    selecteddata?.currency === "INR"
      ? 350 * sessions
      : selecteddata?.currency === "NPR"
      ? 500 * sessions
      : 350 * sessions;
  const Total_Amount_Discount = Total_Amount - discount;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}paymentmode`);
        if (response.ok) {
          const data = await response.json();
          const activePayments = data.filter((item) => item.is_active === 1 || true);
          setPaymentModes(activePayments);

          if (activePayments?.length > 0) {
            setPaymentMode(activePayments[0].id);
          }
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  console.log(paymentmodes);
  const handlePaymentModeChange = (event) => {
    setPaymentMode(event.target.value);
  };

  useEffect(() => {
    // Check if all required fields are filled
    if (sessions && paymentMode && statusname) {
      setIsSubmitDisabled(false);
    } else {
      setIsSubmitDisabled(true);
    }
  }, [sessions, paymentMode, statusname]);

  const handleSubmit = async () => {
    if (discount > Total_Amount) {
      showSnackbar("Discount amount cannot be more than paid amount", "error");
      return;
    }

    if (offerDiscount && (discount === "" || discount === null)) {
      showSnackbar("Please add discount amount", "error");
      return;
    }
    const formdata = {
      enquiry_id: enquiryId,
      student_id: studentId,
      class_id: clasId,
      package_id: packageId,
      number_of_extended_sessions: parseInt(sessions),
      total_amount: Total_Amount_Discount,
      discount_amount: parseInt(discount) || null,
      is_discount: offerDiscount,
      payment_type: selectedType,
      payment_mode_id: paymentMode,
      payment_status: statusname,
      is_class_extension: classextension,
      user_id: parseInt(userId),
      currency: selecteddata?.currency,
    };
    try {
      const response = await fetch(`${API_ENDPOINT}stdclassextension`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      });

      const result = await response.json();
      if (response.ok) {
        showSnackbar("Class Extent Successfully");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 409) {
        showSnackbar(result.message, "error");
      } else if (response.status === 500) {
        showSnackbar("Internal Server Error", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5">How many session to extend</Typography>
          <CustomTextFieldComp
            fullWidth
            size="normal"
            value={sessions}
            onChange={handlesessionchange}
            sx={{ mb: 1, width: "100%" }}
            type="number"
            InputProps={{
              style: { borderRadius: "10px" },
            }}
          />
        </Grid>

        <Grid item xs={12} lg={12} md={12} sm={12}>
          <FormControl fullWidth>
            <Typography variant="h6">Payment Status</Typography>
            <Select
              size="normal"
              value={statusname}
              style={{ borderRadius: "10px" }}
              onChange={handleChange}
            >
              <MenuItem value="pending">Pending</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5">Apply Discount</Typography>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={offerDiscount === true}
                  onChange={() => handleOfferDiscountChange(true)}
                />
              }
              label="Yes"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={offerDiscount === false}
                  onChange={() => handleOfferDiscountChange(false)}
                />
              }
              label="No"
            />
          </FormGroup>
        </Grid>

        {/* <Grid item xs={12}>

               </Grid> */}

        {offerDiscount && (
          <Grid item xs={12}>
            <Typography variant="h5">
              Discount Amount({selecteddata?.currency})
            </Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              value={discount}
              onChange={handleDiscountchange}
              sx={{ mb: 1, width: "100%" }}
              type="number"
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="h5">Payment Type</Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={selectedType} // Controlled by state
              onChange={(e) => setSelectedType(e.target.value)}
            >
              <FormControlLabel
                value="fullPayment"
                control={<Radio />}
                label="Full Payment"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12}>
          <Typography variant="h6">Payment mode</Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={paymentMode}
              onChange={handlePaymentModeChange}
            >
              {paymentmodes.map((mode, index) => (
                <FormControlLabel
                  key={mode.id}
                  value={mode.id}
                  control={<Radio />}
                  label={mode.payment_mode}
                  // disabled={mode.id === 2}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h4">
            Original Price: {Total_Amount} {selecteddata?.currency}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <Typography variant="h4">
            Total Amount To Be Paid : {Total_Amount_Discount}{" "}
            {selecteddata?.currency}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={12} textAlign="center">
          <Button
            variant="contained"
            color="secondary"
            disabled={isSubmitDisabled}
            onClick={handleSubmit}
          >
            Submit Form
          </Button>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
